import React from 'react';
import styled, { css } from 'styled-components';
import Color from '@styles/Color';
import InfoBtn from '@components/dataEntry/button/InfoBtn';

const LabelSizeMap = {
  md: css`
    font-size: 14px;
  `,
  sm: css`
    font-size: 12px;
    color: var(--subTextColor);
    margin: 0;
  `,
};
const LabelBase = styled.span<{
  required?: boolean;
  size?: 'md' | 'sm';
}>`
  font-weight: 700;
  margin: 0 0 0 4px;
  position: relative;
  display: inline-flex;
  gap: 12px;
  align-items: center;

  ${({ size }) => size && LabelSizeMap[size]};

  &::after {
    content: '';
    position: absolute;
    top: 4px;
    right: -12px;
    width: 6px;
    height: 6px;
    background-color: ${Color.RED_7};
    border-radius: 50px;
    display: ${({ required }) => (required ? 'inherit' : 'none')};
  }


`;

const Wrap = styled.div<{ $hasDescription?: boolean }>`
  margin: 8px 0;
  text-align: left;
  width: auto;
  display: flex;
  align-items: center;

  ${({ $hasDescription }) => $hasDescription && css`
    margin: 8px 0 0 0;
  `}
`;

type LabelProps = {
  required?: boolean;
  children: any;
  style?: React.CSSProperties | any;
  infoLink?: IinfoLink;
  size?: 'md' | 'sm';
  hasDescription?: boolean;
};

function Label({
  required,
  style,
  children,
  infoLink,
  size = 'md',
  hasDescription = false,
}: LabelProps) {
  return (
    <Wrap style={style} $hasDescription={hasDescription}>
      <LabelBase required={required} className="label" size={size}>
        {children}
        {infoLink && <InfoBtn {...infoLink} />}
      </LabelBase>
    </Wrap>
  );
}

export default React.memo(Label);
